import { useLazyQuery } from "@apollo/client"
import { get } from "lodash-es"
import React, { useState, useEffect } from "react"
import StaticSelector from "../Atoms/StaticSelector"
const LazyDynamicSelector = ({ query, ...staticSelectorProps }) => {
  const [searchQuery, setSearchQuery] = useState("")
  const [getData, { data, loading }] = useLazyQuery(query, {
    variables: {
      query: searchQuery,
      first: 10,
    },
  })

  useEffect(() => {
    getData()
  }, [query, getData])

  let list = []
  if (data) {
    const key = Object.keys(data)[0]
    list = get(data, key, [])
  }
  return (
    <StaticSelector
      loading={loading}
      items={list}
      {...staticSelectorProps}
      onQueryChange={query => setSearchQuery(query)}
    />
  )
}

export default LazyDynamicSelector
